<template>
    <b-row v-if="row.executionStatusCode !== 0 && row.errordata === 'Error'">
        
        <a  @click="showDialog">Exception</a>
    </b-row>
    <b-row v-else>
    </b-row>
</template>

<script>



export default {
    data() {
        return {
          
        }
    },
    props: ['row'],
    
    components: {
    
    },

    created() {
        var that = this;
      
    },

    methods: {
        showDialog() {
            this.$parent.$parent.showException(this.row);
        }
    }
}

</script>